import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import Multiselect from 'multiselect-react-dropdown';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const CategoryCommissionList = {
    bill_payments: 1.1,
    grocery: 4.52,
    drugstore: 1.15,
    beauty: 6.46,
    home: 6.46,
    electronics: 1.15,
    baby_product: 6.46,
    watch: 6.46,
    toy: 6.81,
    fresh_produce: 1.15,
    kitchen: 6.46,
    home_entertainment: 3.88,
    wireless: 3.88,
    musical_instruments: 6.46,
    pet_products: 7.63,
    biss: 1.15,
    value_added_services: 1.15,
    wireless_accessory: 3.88,
    lawn_and_garden: 6.46,
    jewelry: 9.48,
    personal_care_appliances: 6.46,
    book: 7.26,
    sports: 6.81,
    pc: 3.88,
    furniture: 6.81,
    shoes: 8.73,
    automotive: 6.46,
    apparel: 9.19,
    consumables_physical_gift_cards: 2.29,
    home_improvement: 6.46,
    luggage: 6.81,
    fresh_perishable: 1.15,
    office_product: 6.46,
    major_appliances: 1.15,
    software: 4.85,
    digital_devices_4: 7.26,
    luxury_beauty: 5.96,
    consumables_email_gift_cards: 1.15,
    amazon_money: 1.15,
    digital_products_3: 1.15,
    video_games: 6.46,
    softlines_private_label: 1.15,
    digital_accessories_4: 1.15
};
export function MaterialUIPickers(props) {
    if (props.id == 'date-picker-inline1') {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = date.setDate(date.getDate() - 30);
        //var firstDay = new Date(y, m, 1);
    } else {
        //var firstDay = new Date();
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        //var firstDay = date.setDate(date.getDate() -15);
    }
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    //maxDate={props.id == 'date-picker-inline2' ? new Date(firstDay):''}
                    maxDate={new Date()}
                    autoOk={true}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

function getColumns() {
    let columns = [
        { title: 'Category', field: 'Category' },
        { title: 'Name', field: 'Name' },
        { title: 'ASIN', field: 'ASIN' },
        { title: 'OrderID', field: 'Order Id' },
        { title: 'Date', field: 'Date' ,render: (item) => getFormattedDateTime(item.Date)},
        { title: 'Qty', field: 'Qty' },
        { title: 'Price(₹)', field: 'Price(₹)' },
        {
            title: 'Earning(₹)',
            field: 'Ops (INR)',
            render: (item) => getEarning(item)
        }
    ];
    return columns;
}

const pageSizes = [5, 10, 25, 50, 100];
const searchBy = [
    { key: 'Category', value: 'Category' },
    { key: 'Name', value: 'Name' },
    { key: 'ASIN', value: 'ASIN' },
    { key: 'OrderID', value: 'Order Id' },
    { key: 'Qty', value: 'Qty' },
    { key: 'Price(₹)', value: 'Price(₹)' }
];

function getEarning(item) {
    if (CategoryCommissionList[item.Category.toString()]) {
        var CategoryCommission =
            CategoryCommissionList[item.Category.toString()];
    } else {
        var CategoryCommission = 1.1;
    }

    return ((CategoryCommission / 100) * item['Ops (INR)']).toFixed(2);
}

function getEarningColumns() {
    let columns = [
        { title: 'StoreEmail', field: 'StoreEmail' },
        { title: 'StoreTag', field: 'Tag' },
        { title: 'Earning(₹)', field: 'OPS' }
    ];
    return columns;
}

class EarningList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'Category',
        storeTag: '',
        selectedStoreTag: '',
        backArrow: false,
        fromDate: this.getFormattedDate(new Date()),
        toDate: this.getFormattedDateTo(new Date()),
        flag: 0,
        alert: 0,
        alertMessage: '',
        data: [],
        tagOptions: [],
        selectedTags: [],
        allEarning: []
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    dataArray = [];

    getFormattedDate(date) {
        // date.setDate(date.getDate() -30);
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getFormattedDateTo(date) {
        //date.setDate(date.getDate() -15);
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getNextDate(todate) {
        var date = new Date(todate);
        var dd = String(date.getDate() + 1).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    async componentDidMount() {
        this._isMounted = true;
        if (this._isMounted) {
            var date = new Date();
            date.setDate(date.getDate() - 30);
            this.setState({ fromDate: this.getFormattedDate(date) });
        }
    }

    onSelect = (selectedList, selectedItem) => {
        if (this._isMounted) {
            this.setState({ flag: 0, selectedTags: selectedList });
        }
    };

    onRemove = (selectedList, removedItem) => {
        if (this._isMounted) {
            this.setState({ flag: 0, selectedTags: selectedList });
        }
    };

    onSearch = async (search_key) => {

        var userRole = this.props.role
        if (this.props.role === 'Admins') {
            var userRole = 'Admin';
        }
        if (this.props.role === 'Employees') {
            var userRole = 'Employee';
        }
        if (this.props.role === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.role === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.role === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }
        let bodyData = {
            search_key: search_key,
            search_by: 'StoreTag',
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:userRole,
            perPage: 10
        };

        await RestServices.SearchStoreTagsMapping(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreTags) => {
                let tagOptions = [];
                //tagOptions.push({ StoreTag:'smad4ibex-21'})
                await StoreTags.list.forEach(async (storetag) => {
                    tagOptions.push({ StoreTag: storetag });
                });
                if (this._isMounted) {
                    this.setState({
                        flag: 0,
                        tagOptions: tagOptions
                    });
                }
            })
            .catch((err) => {});
    };

    async fetchTotalEarning() {
        if (this._isMounted) {
            this.setState({ flag: 1 });
        }
        var changeDataStateBH = (dataArray) => {
            if (this._isMounted) {
                this.setState({
                    allEarning: dataArray,
                    backArrow: true,
                    flag: 3,
                    alert: 0
                });
            }
        };
        let bodyData = {
            storeTags: this.state.selectedTags,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
        };
        

        await RestServices.fetchStoreTagsEarnings(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.length > 0) {
                    let storeTagsData = [];

                    await responseData.forEach(async (item) => {
                        var tag = item.Tag;
                        var StoreEmail = item.StoreEmail;

                        if (CategoryCommissionList[item.Category.toString()]) {
                            var CategoryCommission =
                                CategoryCommissionList[
                                    item.Category.toString()
                                ];
                        } else {
                            var CategoryCommission = 1.1;
                        }

                        var OpsTotal =
                            (CategoryCommission / 100) * item['Ops (INR)'];
                        if (storeTagsData.some((item) => tag === item.Tag)) {
                            storeTagsData.some(function (el) {
                                if (el.Tag === tag) {
                                    el.OPS = (
                                        parseFloat(el.OPS) +
                                        parseFloat(OpsTotal)
                                    ).toFixed(2);
                                }
                            });
                        } else {
                            storeTagsData.push({
                                StoreEmail: StoreEmail,
                                Tag: tag,
                                OPS: OpsTotal
                            });
                        }
                    });
                    changeDataStateBH(storeTagsData);
                } else {
                    if (this._isMounted) {
                        this.setState({
                            backArrow: false,
                            flag: 0,
                            alert: 1,
                            alertMessage:
                                'No Results Found between the date range...'
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        backArrow: false,
                        flag: 0,
                        alert: 1,
                        alertMessage: err.error
                    });
                }
            });
    }

    async fetchData() {
        if (this._isMounted) {
            this.setState({
                pageNumber: 0,
                StartAt: [],
                LastDocument: false,
                FirstDocument: false
            });
        }
        setTimeout(() => {
            this.loadData();
        }, 500);
    }
    async loadData() {
        //let selectedStoreTagList =[];
        //selectedStoreTagList.push({StoreTag:this.state.storeTag})

        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            DetailsType: 'Fee_Orders',
            storeTags: this.state.selectedTags,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            DateLabel: 'Date',
            TagLabel: 'Tag'
        };
        
        await RestServices.fetchStoreTagsEarningsPaginate(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            backArrow: false,
                            flag: 2,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    

                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    
                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: 2,
                            alert: 0
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        backArrow: false,
                        flag: 0,
                        alert: 1,
                        alertMessage: err.error
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    render() {
        return (
            <div>
                <hr />
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag === 1 && <Spinner animation="border" />}

                <div>
                    <Row>
                        <Col>
                            <div style={{ marginTop: '1.3rem' }}>
                                <Multiselect
                                    placeholder="Select Store Tag"
                                    options={this.state.tagOptions}
                                    displayValue="StoreTag"
                                    selectedValues={this.state.selectedTags}
                                    onSelect={this.onSelect}
                                    onRemove={this.onRemove}
                                    onSearch={this.onSearch}
                                />
                            </div>
                        </Col>
                        <Col>
                            <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        fromDate: this.getFormattedDate(date)
                                    });
                                }}
                            />
                        </Col>

                        <Col>
                            <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        toDate: this.getFormattedDate(date)
                                    });
                                }}
                            />
                        </Col>
                        <Col>
                            <Button
                                onClick={() => {
                                    this.fetchData();
                                }}
                                style={{ marginTop: '1.3rem' }}
                            >
                                Fetch
                            </Button>
                            <Button
                                onClick={() => {
                                    this.fetchTotalEarning();
                                }}
                                style={{
                                    marginTop: '1.3rem',
                                    marginLeft: '1rem'
                                }}
                            >
                                Total Earning
                            </Button>
                        </Col>
                    </Row>
                    <Row></Row>
                </div>

                {this.state.flag === 2 && (
                    <div>
                        {/*<div><hr/></div>
                <Row style={{justifyContent:"right"}}>
                <Col style={{justifyContent:"right",textAlign:"right"}}>
                <Form.Group as={Row} style={{justifyContent:"right",marginRight:"0"}}>
                
                <select className="form-control" style={{width:"auto"}} name="search_by"  onChange={this.onChangeValues} value={this.state.search_by}>
						{searchBy.map((search) => (
						  <option key={search.value} value={search.value}>
							Search By {search.key}
						  </option>
						))}
			   </select>
			   <Form.Control style={{marginLeft:"1rem", marginRight:"1rem",width:"auto"}} placeholder="Search key" type="text" name="search_key" value={this.state.search_key} onChange={this.onChangeValues} />
                <Button variant="primary"  onClick={this.submitSearch}>
					Search
				</Button>
				
				<Button style={{marginLeft:"1rem"}} variant="primary"  onClick={this.restSearch}>
					Reset
				</Button>
                </Form.Group>
            </Col>
            </Row>*/}
                        <MaterialTable
                            title="Orders Details"
                            columns={[
                                {
                                    title: 'Name',
                                    field: 'Name',
                                    render: (row) => (
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue'
                                            }}
                                            onClick={(e) =>
                                                window.open(
                                                    'https://www.amazon.in/dp/' +
                                                        row.ASIN
                                                )
                                            }
                                        >
                                            {row.Name.slice(0, 20) + '...'}
                                        </div>
                                    )
                                },
                                {
                                    title: 'ASIN',
                                    field: 'ASIN',
                                    render: (row) => (
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue'
                                            }}
                                            onClick={(e) =>
                                                window.open(
                                                    'https://www.amazon.in/dp/' +
                                                        row.ASIN
                                                )
                                            }
                                        >
                                            {row.ASIN}
                                        </div>
                                    )
                                },
                                { title: 'Category', field: 'Category' },
                                { title: 'OrderID', field: 'Order Id' },
                                { title: 'Date', field: 'Date' },
                                { title: 'Qty', field: 'Qty' },
                                { title: 'Price(₹)', field: 'Price(₹)' },
                                {
                                    title: 'Earning(₹)',
                                    field: 'Ops (INR)',
                                    render: (item) => getEarning(item)
                                }
                            ]}
                            data={this.state.data}
                            options={{
                                exportButton: {
                                    csv: true
                                },
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />
                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                {this.state.flag === 3 && (
                    <MaterialTable
                        components={{ Pagination: PatchedPagination }}
                        title="Total Earnings"
                        columns={getEarningColumns()}
                        data={this.state.allEarning}
                        options={{
                            exportButton: {
                                csv: true
                            },
                            filtering: true,
                            actionsColumnIndex: -1,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                    />
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(EarningList);
